import type { RootState } from "@/app/store";

export const selectGarage = (state: RootState) => state.garage;
export const selectGarageCars = (state: RootState) => state.garage.myGarageList;
export const selectIsGarageBusy = (state: RootState) =>
  state.garage.isLoadingCarAction;
